import {useState, useEffect} from "react";
import {createImage, updateImage, deleteImage} from '../api/image'
import {toBase64} from '../utils/toBase64';
import {Paper, Button, FormControl, MenuItem, Select, Typography, Grid} from "@material-ui/core";
import UploadIconBlack from '../assets/icons/upload_black_32.png'
import UploadImagesDialog from "../components/UploadImagesDialog";
import ImageSetEditor from "../components/ImageSetEditor";
import {useAlert} from "react-alert";
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibraryOutlined';
import StepNavigator from "../components/StepNavigator";
import {makeStyles} from "@material-ui/core/styles";
import AdditionalNotes from "../components/AdditionalNotes";


const useStyles = makeStyles((theme) => ({
    container: {
        height: '100%',
        position: 'relative',
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        flex: '1',
        display: 'flex',
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        background: '#2f3135'
    },
    narrowGrid: {
        '& > .MuiGrid-grid-xs-2': {
            flexGrow: 0,
            maxWidth: '14%',
            flexBasis: '14%',
        },
        '& > .MuiGrid-grid-xs-10': {
            flexGrow: 0,
            maxWidth: '86%',
            flexBasis: '86%',
            '@media (max-width:1366px)': {
                flex: '1',
            },
        }
    },
    pageNavigation: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.shape.borderRadius,
        background: '#32373D',
        minWidth: 180,
        boxShadow: '0px 4px 4px #000000',
        padding: '0 !important',
        overflow: 'hidden',
        '& .MuiTypography-h4': {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(4),
            '@media (max-width:1440px)': {
                fontSize: '1.5rem',
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
            },
        },
        '& ul': {
            textAlign: 'left',
            marginBottom: theme.spacing(4),
            '@media (max-width:1440px)': {
                paddingLeft: theme.spacing(2),
                marginBottom: theme.spacing(2),
                fontSize: '0.75rem',
            },
        },
        '& .MuiButton-label': {
            '@media ( max-width: 1440px)': {
                fontSize: '0.70rem',
                '& > .MuiButton-startIcon img': {
                    height: 12,
                }
            }
        }
    },
    pageContent: {
        padding: `16px !important`,
        borderRadius: theme.shape.borderRadius,
        overflowY: 'auto',
    },
    content: {
        flex: '1',
        textAlign: 'center',
        padding: theme.spacing(2),
        width: '100%',
    },
    badge: {
        '.MuiInputBase-input &': {
            display: 'none',
        },
        display: 'inline-block',
        width: 8,
        height: 8,
        fontSize: 10,
        color: '#000',
        textAlign: 'center',
        borderRadius: '100%',
        marginRight: 8,
        background: theme.customColors.yellow,
    }
}));

const SelectImageMessage = () => {
    return (
        <div style={{height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', textAlign: 'center'}}>
            <PhotoLibraryIcon style={{fontSize: '8rem', marginBottom: 16}} />
            <Typography>
                Please select the activity and click on the <b>Upload Pictures</b> button to start adding pictures of your activity.
            </Typography>
        </div>

    )
}

export default function ActivitiesPage({data, onNext, onPrev, pageParams, onUpdate, token, onLoading}) {
    const classes = useStyles();
    const alert = useAlert();

    const [updateTime, setUpdateTime] = useState(+Date.now());
    const [selectedActivity, setSelectedActivity] = useState(-1);
    const [selectedBranch, setSelectedBranch] = useState(-1);
    const [availableActivities, setAvailableActivities] = useState([]);
    const [uploadImageDialogActive, setUploadImageDialogActive] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (data.branches.length === 1) {
            setSelectedBranch(data.branches[0]._id) // choose the only branch available
        }
    }, [data.branches])


    useEffect(() => {
        if (pageParams.activity && pageParams.branch) {
            setSelectedBranch(pageParams.branch)
            let filteredActivities = [];
            if (selectedBranch === -2) {
                filteredActivities = data.activities.filter(a => a._id === a.activity_template_id);
            } else {
                filteredActivities = data.activities.filter(a => a.branch_id === pageParams.branch)
            }
            console.log(filteredActivities)
            setAvailableActivities(filteredActivities);
            setSelectedActivity(filteredActivities.findIndex(a => a._id === pageParams.activity));
            return;
        }

        if (selectedBranch === -1) {
            return;
        }
        // show all template activities
        if (selectedBranch === -2) {
            setAvailableActivities(data.activities.filter(a => a._id === a.activity_template_id))
        } else {
            setAvailableActivities(data.activities.filter(a => a.branch_id === selectedBranch));
        }
        setSelectedActivity(-1);

    }, [selectedBranch, data.activities, pageParams])


    const handleImageUpdate = (index, image) => {
        const activityId = availableActivities[selectedActivity]._id;
        const activityIndex = data.activities.findIndex(a => a._id === activityId)
        onLoading(true);
        updateImage({
            imageId: image._id,
            editedUri: image.editedUri,
            editData: image.editData
        }, token).then(res => {
            res.editedUri = res.editedUri + `?ts=${+Date.now()}`
            data.activities[activityIndex].images[index] = res;
            onUpdate({
                ...data,
                activities: data.activities
            })
            setUpdateTime(+Date.now());
        }).catch(() => alert.show("Failed to update image")).then(() => onLoading(false))
    }

    const handleImageAdd = (image) => {
        // selectedActivity contains index in availableActivities
        const activityId = availableActivities[selectedActivity]._id;
        console.log("adding image")
        // find the old index
        const index = data.activities.findIndex(a => a._id === activityId)
        image.editedUri = image.editedUri + `?ts=${+Date.now()}`
        data.activities[index].images.push(image);
        onUpdate({
            ...data,
            activities: data.activities
        })
        setUpdateTime(+Date.now());
    }


    const handleImageDelete = (index) => {

        const activityId = availableActivities[selectedActivity]._id;
        const imageId = availableActivities[selectedActivity].images[index]._id;

        console.log({activityId, imageId})

        deleteImage(imageId, token).then(_ => {
            const i = data.activities.findIndex(a => a._id === activityId)
            data.activities[i].images.splice(index, 1);
            console.log(data.activities[i].images)
            onUpdate({
                ...data,
                activities: data.activities
            })
            setUpdateTime(+Date.now());
        }).catch(() => {
            alert.show("Failed to delete image")
        })
    }


    const handleUpload = async (files) => {
        console.log(files);
        onLoading(true);
        const promises = files.map(async file => {
            try {
                const imageUri = await toBase64(file)
                const res = await createImage({
                    sourceId: availableActivities[selectedActivity]._id,
                    fileName: `${+Date.now()}.png`,
                    imageType: 'ACTIVITY_IMAGE',
                    originalUri: imageUri
                }, token);
                handleImageAdd(res);
                return res;
            } catch (e) {
                alert.show("Failed to upload image")
                console.error(e);
            }
        });
        setUploadImageDialogActive(false);
        await Promise.all(promises);
        console.log(promises)
        onLoading(false);

    }


    const handleNoteChange = (value) => {
        const activityId = availableActivities[selectedActivity]._id;
        const note = {
            sourceId: activityId,
            type: 'ACTIVITY_NOTE',
            content: value,
        }
        // find the old index
        const index = data.activities.findIndex(a => a._id === activityId)
        data.activities[index].note = note;
        onUpdate({
            ...data,
            activities: data.activities
        })
    }
    // use useEffect to set available activiies for the branch

    return (
        <>
            <Paper className={classes.container}>
                <Grid container spacing={1} className={classes.narrowGrid}>
                    <Grid item xs={2} className={classes.pageNavigation}>
                        <div className={classes.content}>
                            <Typography variant="h4" gutterBottom>Activities</Typography>
                            <ul>
                                <li> Please upload atleast three pictures per activity.</li>
                                <li> Please check that the right branch is displayed in the branch field.</li>
                            </ul>
                            <FormControl fullWidth>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedBranch}
                                    disabled={data.tokenType === 'BRANCH'}
                                    onChange={(e) => setSelectedBranch(e.target.value)}
                                >
                                    <MenuItem value={-1} disabled>Select Branch</MenuItem>
                                    <MenuItem value={-2}>All Branches</MenuItem>
                                    {
                                        data.branches.map(branch => (
                                            <MenuItem value={branch._id} key={branch._id}>{branch?.info?.name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <br /><br />
                            <FormControl fullWidth>
                                <Select
                                    labelId="activity-select-label"
                                    id="activity-select"
                                    value={selectedActivity}
                                    onChange={(e) => setSelectedActivity(e.target.value)}
                                >
                                    <MenuItem value={-1} disabled>Select Activity</MenuItem>
                                    {
                                        availableActivities.map((activity, i) => (
                                            <MenuItem value={i} key={activity._id}>
                                                {activity?.images?.length === 0 && <div className={classes.badge}></div>} {activity?.info?.name}
                                            </MenuItem>)
                                        )
                                    }
                                </Select>
                            </FormControl>
                            <br /><br />
                            <Button variant="contained" color="primary"
                                disabled={selectedBranch === -1 || selectedActivity === -1}
                                onClick={() => setUploadImageDialogActive(true)} startIcon={<img alt="upload" src={UploadIconBlack} height="18" />}>Upload Pictures</Button>
                            <ul>
                                <li>
                                    The size of each picture should be no less than 500 Kb and no greater than 5 Mb.
                                </li>
                                <li>
                                    The picture type should be .jpg or .jpeg.
                                </li>
                            </ul>
                        </div>
                        <AdditionalNotes
                            disabled={selectedActivity === -1}
                            value={availableActivities[selectedActivity]?.note?.content}
                            onChange={handleNoteChange} />
                    </Grid>
                    <Grid item xs={10} className={classes.pageContent}>
                        {(selectedBranch === -1 || selectedActivity === -1 || availableActivities[selectedActivity].images.length === 0) ? <SelectImageMessage /> : (
                            <ImageSetEditor
                                images={availableActivities[selectedActivity].images}
                                onEditing={setIsEditing}
                                updateTime={updateTime}
                                handleDelete={handleImageDelete}
                                handleUpdate={handleImageUpdate}
                            />
                        )}
                    </Grid>
                </Grid>
            </Paper>
            <UploadImagesDialog isOpen={uploadImageDialogActive} onClose={() => setUploadImageDialogActive(false)} onUpload={handleUpload} />
            <StepNavigator disabled={isEditing} onNext={onNext} onPrev={onPrev} />
        </>
    );
}
